
export default function Trust() {
  const stats = [
    {
      icon: 'ri-user-star-line',
      number: '500+',
      label: 'Clientes Satisfechos'
    },
    {
      icon: 'ri-tools-line',
      number: '800+',
      label: 'Pozos Perforados'
    },
    {
      icon: 'ri-calendar-check-line',
      number: '15+',
      label: 'Años de Experiencia'
    },
    {
      icon: 'ri-map-pin-line',
      number: '100%',
      label: 'Cobertura Regional'
    }
  ];

  return (
    <section className="py-10 sm:py-16 lg:py-20 bg-gradient-to-br from-blue-600 to-blue-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-2 sm:mb-4">
            Números que nos respaldan
          </h2>
          <p className="text-sm sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
            Nuestra trayectoria habla por sí sola
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 lg:gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm p-4 sm:p-6 lg:p-8 rounded-xl border border-white/20 text-center hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-10 h-10 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-4">
                <i className={`${stat.icon} text-lg sm:text-2xl lg:text-3xl text-white`}></i>
              </div>
              <div className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-1 sm:mb-2">
                {stat.number}
              </div>
              <div className="text-xs sm:text-base md:text-lg text-white/90 font-semibold leading-tight">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
